

/**
 * @param {*} any
 * @returns {Boolean}
 */
export default function(any) {
    return any !== null && typeof any === 'object';
}


/** WEBPACK FOOTER **
 ** C:/OpenServer/domains/nerv.recursive-iterator.github.my/src/lang/isObject.js
 **/